import { useEffect, useState } from "react";
import LoadingView from "../../../components/LoadingView";
import ErrorView from "../../../components/ErrorView";
import { Heading } from "../../../design/heading";
import moment from "moment";
import { Text } from "../../../design/text";
import DeleteHolidayScheduleButton from "../../../components/DeleteHolidaySchedule";
import HolidayScheduleStatusBadge from "../../../components/HolidayScheduleStatusBadge";
import HolidayScheduleButton from "../../../components/HolidayScheduleButton";
import { Navbar, NavbarItem } from "../../../design/navbar";
import FileViewer from "../../../components/FileViewer";
import { HolidayScheduleService } from "../../../services/HolidayScheduleService";
import { HolidaySchedule } from "../../../models/HolidaySchedule";
import DragAndDropFile from "../../../DragAndDropFile";

interface Props {
  holidaySchedule: HolidaySchedule;
}

const HolidayScheduleDocument: React.FC<Props> = ({ holidaySchedule }) => {
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    if (!holidaySchedule?.blobName) return;
    const fetchFileUrl = async () => {
      const url = await HolidayScheduleService.getDownloadURL(
        holidaySchedule._id,
      );
      setFileUrl(url);
      setIsLoading(false);
    };
    fetchFileUrl();
  }, [holidaySchedule]);

  const handleFileUpload = async (file: File) => {
    setIsUploading(true);
    try {
      await HolidayScheduleService.uploadFile(holidaySchedule._id, file);
      const url = await HolidayScheduleService.getDownloadURL(
        holidaySchedule._id,
      );
      setFileUrl(url);
    } catch (error) {
      console.error("Failed to upload file:", error);
      setFileUrl(null);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>
      {fileUrl && <FileViewer fileUrl={fileUrl} />}
      {!fileUrl && !isLoading && (
        <DragAndDropFile onFileDrop={handleFileUpload} />
      )}
    </>
  );
};

export default HolidayScheduleDocument;
